(ns frontend.view.settings2.surveys.db
  (:require
   [frontend.db :as app-db]
   [reagent.core :as r]))

(def state (r/cursor app-db/app-state [:views :settings :surveys]))
